import type { SystemReference, VariantReference } from '../types';
import axiosInstance from './axiosInstance';

export const fetchSystems = async (getToken: () => Promise<string>): Promise<SystemReference[]> => {
  const token = await getToken();
  const response = await axiosInstance.get<SystemReference[]>('/systems', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchSystemVariants = async (getToken: () => Promise<string>): Promise<VariantReference[]> => {
  const token = await getToken();
  const response = await axiosInstance.get<VariantReference[]>('/systems/variants', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
